window.NORTHY_SITE = {
  productionDomain: 'northygym.com.au',
  status: 'Local development of the future official Northy Gym website',
  gameDay: {
    sourceUrl: 'https://www.northygym.com.au/pages/ng-game-day',
    ticketUrl: 'https://www.eventbrite.com/e/gameday-spring-tickets-1996323809253',
    checkedOn: '2026-10-19',
    title: 'GameDay Spring',
    dateLabel: '28 November 2026 · 8 am–2 pm',
    dateNote: 'Verified on the current GameDay Spring Eventbrite listing, 19 October 2026. Doors 7:30 am; ages 13+.'
  },
  shop: {
    provider: 'Shopify',
    url: 'https://www.northygym.com.au/collections/all',
    checkedOn: '2026-10-16',
    categories: [
      {title:'Protein Powders',detail:'Whey, plant protein & mass gainers',handle:'protein-powders'},
      {title:'Pre-Workout',detail:'Powders, sachets & gummies',handle:'pre-workout'},
      {title:'Creatine',detail:'Powders, gummies & drinks',handle:'creatine'},
      {title:'Hydration & Electrolytes',detail:'Mixes, water & sports drinks',handle:'hydration-electrolytes'},
      {title:'Protein Snacks & Foods',detail:'Bars, cookies, gummies & more',handle:'protein-snacks-foods'},
      {title:'Ready-to-Drink',detail:'Protein shakes & chilled drinks',handle:'rtd-range'},
      {title:'Health & Recovery',detail:'Greens, collagen, amino acids & supplements',handle:'health-recovery'},
      {title:'Weight Management',detail:'Browse the dedicated supplement range',handle:'weight-management'},
      {title:'Functional Coffee',detail:'Before You Speak coffee range',handle:'functional-coffee'},
      {title:'Pilates Socks & Accessories',detail:'Grip socks & studio essentials',handle:'pilates'},
      {title:'Northy Apparel',detail:'Northy tees, tanks & hoodies',handle:'apparel'},
      {title:'Run Club Accessories',detail:'Running vests, belts & hydration gear',handle:'run-club-accessories'},
      {title:'Energy Gels & Fuel',detail:'Revvies gels & energy strips',handle:'energy-gels-fuel'},
      {title:'Training Accessories',detail:'Training tech & useful extras',handle:'training-accessories'}
    ],
    featuredCollections: [
      {title:'Staff Picks',handle:'staff-picks'},
      {title:'Rule 1',handle:'rule-1'}
    ]
  }
};
